var getNative = require('./_getNative'),
    root = require('./_root');

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;



/*****************
 ** WEBPACK FOOTER
 ** ./~/react-tag-input/~/lodash/_Promise.js
 ** module id = 1186
 ** module chunks = 0
 **/